// localize the requires here
/* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */
export const asanaLogo: string = require("./asana.svg");
export const asanaTask: string = require("./asana-task.svg");
export const githubLogo: string = require("./github.svg");
export const jiraLogo: string = require("./jira.svg");
export const pagerDutyLogo: string = require("./pagerduty.svg");
export const slackLogo: string = require("./slack.svg");
export const zoomLogo: string = require("./zoom.svg");
